module.exports = __webpack_public_path__ + "img/mail.b50e4cca.svg";